import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import ViewEnquiryComp from "./Component/ViewEnquiryComp"

const ViewEnquiry =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewEnquiryComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewEnquiry